import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function TeacherAccessNotification(): React.ReactElement {
  const { t } = useTranslation('gamification')
  return (
    <div className="flex w-full p-2">
      <div className="p-2 rounded bg-gradient-dashboard min-w-23">
        <ResponsiveImage fit="contain" height={115} imageWidths="100" srcKey="icons/all-math-v1.png" width={100} />
      </div>
      <div className="flex flex-col ml-4">
        <h3 className="font-semibold text-md">{t('accountUpgrade')}</h3>
        <p className="text-sm text-black-light-fade">{t('freeAccess')}</p>
      </div>
    </div>
  )
}
